import API from "../API/API";
import { HeaderNextType } from "../commons/interfaces";

export const getData = async (url: any) => {
  const response = await API.get(url);
  return response.data;
};

export const postData = async (
  url: string,
  params: any,
  header?: HeaderNextType
) => {
  const response = await API.post(url, params, params.headers);
  return response.data;
};

export const patchData = async (url: string, params: any) => {
  const response = await API.patch(url, params);
  return response.data;
};

export const deleteData = async (url: string, params: any) => {
  const response = await API.delete(url, params);
  return response.data;
};

export const putData = async (url: string, params: any) => {
  const response = await API.put(url, params);
  return response.data;
};
